import { useLocale } from "next-intl";
import { isLanguageCode } from "@/utils/helpers";
import { LocaleType } from "@/hooks/system/useChangeLocale";

export const useStrictLocale = (): LocaleType => {
  const locale = useLocale();
  return isLanguageCode(locale) ? locale : "en";
};
